import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Home } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ManutenzioneCompletionConfirmationPage() {
  const navigate = useNavigate();
  useEffect(() => {
    // Auto-redirect dopo 5 secondi
    const timer = setTimeout(() => {
      navigate('/manutenzione');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-green-50 flex items-center justify-center p-6" data-id="element-1394">
      <div className="max-w-2xl w-full" data-id="element-1395">
        {/* Animated Success Icon */}
        <motion.div initial={{
        scale: 0,
        rotate: -180
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15,
        duration: 0.6
      }} className="flex justify-center mb-8" data-id="element-1396">
          <div className="relative" data-id="element-1397">
            {/* Outer ring animation */}
            <motion.div initial={{
            scale: 0.8,
            opacity: 0
          }} animate={{
            scale: 1.2,
            opacity: 0
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeOut'
          }} className="absolute inset-0 rounded-full bg-green-400" data-id="element-1398" />

            {/* Main circle */}
            <div className="relative w-32 h-32 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-2xl" data-id="element-1399">
              <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              delay: 0.3,
              type: 'spring',
              stiffness: 200,
              damping: 10
            }} data-id="element-1400">
                <CheckCircle className="w-20 h-20 text-white" strokeWidth={2.5} data-id="element-1401" />
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* Success Message */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="text-center mb-8" data-id="element-1402">
          <h1 className="text-5xl font-bold text-navy mb-4" data-id="element-1403">
            Intervento Completato! 🎉
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1404">
            Grazie per il tuo lavoro. La segnalazione è stata chiusa con
            successo.
          </p>
        </motion.div>

        {/* Confetti-like decorative elements */}
        <div className="relative h-20 mb-8 overflow-hidden" data-id="element-1405">
          {[...Array(8)].map((_, i) => <motion.div key={i} initial={{
          y: -100,
          x: Math.random() * 400 - 200,
          rotate: 0
        }} animate={{
          y: 100,
          rotate: 360
        }} transition={{
          delay: 0.5 + i * 0.1,
          duration: 1.5,
          ease: 'easeOut'
        }} className="absolute left-1/2" style={{
          width: 12,
          height: 12,
          backgroundColor: ['#10b981', '#3b82f6', '#f59e0b', '#ef4444'][i % 4],
          borderRadius: i % 2 === 0 ? '50%' : '0%'
        }} data-id="element-1406" />)}
        </div>

        {/* Summary Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 mb-8" data-id="element-1407">
          <div className="space-y-4" data-id="element-1408">
            <div className="flex items-center justify-between pb-4 border-b border-gray-100" data-id="element-1409">
              <span className="text-base text-gray-500" data-id="element-1410">Proprietà</span>
              <span className="text-base font-semibold text-navy" data-id="element-1411">
                Via Roma 123, Apt 4B
              </span>
            </div>
            <div className="flex items-center justify-between pb-4 border-b border-gray-100" data-id="element-1412">
              <span className="text-base text-gray-500" data-id="element-1413">Tipo intervento</span>
              <span className="text-base font-semibold text-navy" data-id="element-1414">
                Oggetto Rotto
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-1415">
              <span className="text-base text-gray-500" data-id="element-1416">Stato</span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 text-green-700 rounded-full text-base font-semibold border border-green-200" data-id="element-1417">
                <CheckCircle className="w-5 h-5" data-id="element-1418" />
                Completato
              </span>
            </div>
          </div>
        </motion.div>

        {/* Action Button */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 0.5
      }} data-id="element-1419">
          <Button onClick={() => navigate('/manutenzione')} className="w-full text-lg h-14 bg-gradient-to-r from-teal-deep to-teal-600 hover:from-teal-600 hover:to-teal-700" data-id="element-1420">
            <Home className="w-5 h-5" data-id="element-1421" />
            Torna alla Dashboard
          </Button>

          <p className="text-center text-sm text-gray-500 mt-4" data-id="element-1422">
            Reindirizzamento automatico tra 5 secondi...
          </p>
        </motion.div>
      </div>
    </div>;
}